import { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";

export default function TopMenu({ label, links, closeParentMenu }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={menuRef}>
      <div
        tabIndex={0}
        type="button"
        className="top-menu"
        aria-expanded={menuOpen}
        aria-haspopup="true"
        onClick={toggleMenu}
        aria-label="Dropdown Hotel Menü,Enter drücken um Dropdown zu sehen"
        onKeyDown={(e) => e.key === "Enter" && toggleMenu()}
      >
        {label}
      </div>

      {menuOpen && (
        <div className="absolute z-10 mt-2 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5">
          <nav className="py-1">
            {links.map((link, index) => (
              <NavLink
                key={link.to}
                to={link.to}
                style={{
                  position: "absolute",
                  marginTop: 3 * index + "rem",
                  width: "8rem",
                  zIndex: "10",
                  backgroundColor: "black",
                }}
                className="block px-4 py-2 text-sm hover:bg-gray-100 menu-children"
                onClick={() => {
                  closeMenu();
                  if (closeParentMenu) closeParentMenu();
                }}
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </div>
  );
}
